<!-- PROFILE PAGE -->
@if (showProfileActivationStatus && this.mode() === 'profile' && !this.isPublicPage) {
  <div
    @growInAnimation
    @growOutAnimation
    class="activation-bar"
    >
    {{ 'research.profile.activate.status.message.' + EsploroPersonPortalFieldTypes[activateStatus] | translate }}
    @if (EsploroPersonPortalFieldTypes[activateStatus] == EsploroPersonPortalFieldTypes.FALSE) {
      <button
        (click)="openActivateDialog()"
        color="primary"
        mat-button
        >
        {{ 'research.profile.activate.status.message.false.action' | translate }}
      </button>
    }
  </div>
}

<!-- SETTING PAGE -->
@if (mode() === 'setting') {
  <div>
    @if (showProfileActivationStatus) {
      <div>
        {{ 'research.profile.activate.status.message.' + EsploroPersonPortalFieldTypes[activateStatus] | translate }}
        @if (EsploroPersonPortalFieldTypes[activateStatus] == EsploroPersonPortalFieldTypes.FALSE) {
          <button
            (click)="openActivateDialog()"
            class="details-toggle is-inline"
            color="primary"
            mat-button
            >
            {{ 'research.profile.activate.status.message.false.action' | translate }}
          </button>
        }
      </div>
    }
    @if (showPublicProfileUrl) {
      <div>
        <div class="margin-top-sm">
          <mulo-copier
            (copied)="onLinkCopied()"
            [content]="profileUrl"
            [copiedLabel]="'research.profile.activate.profile.url.copied' | translate"
            [copyLabel]="'research.profile.activate.profile.url.copy' | translate"
            >
            <span class="padding-sm">
              {{ profileUrl }}
            </span>
          </mulo-copier>
        </div>
      </div>
    }
  </div>
}
